export default __webpack_public_path__ + "static/char-v-18-8403c0b177ecb0d8ebee843d9ca27a13.mp4";